import React, {useEffect} from "react";
import {Helmet} from "react-helmet";
import $ from 'jquery';
import jQuery from 'jquery';
import './Components/jquery-imports-setup';
import {BasicImportCss} from "./Components/BasicImportCss";
import {NavBar} from "./Components/NavBar";
import {Footer} from "./Components/Footer";


export const ProductsGrid = (effect, deps) => {

    return (
        <React.Fragment>

            <BasicImportCss/>

            <div className="wrapper" style={{display: "none"}}>

                <NavBar/>

                <section className="main-header">
                    <header>
                        <div className="container">
                            <h1 className="h2 title">Shop grid</h1>
                            <ol className="breadcrumb breadcrumb-inverted">
                                <li><a href="index.html"><span className="icon icon-home"></span></a></li>
                                <li><a href="category.html">Product Category</a></li>
                                <li><a className="active" href="products-grid.html">Product Sub-category</a></li>
                            </ol>
                        </div>
                    </header>
                </section>


                <section className="products">
                    <header className="hidden">
                        <h3 className="h3 title">Product category grid</h3>
                    </header>

                    <div className="row row-clean">


                        <div className="col-md-3 col-xs-12">
                            <div className="filters">

                                <div className="filter-box">
                                    <div className="title">Price</div>
                                    <div className="filter-content" style={{display: "block"}}>
                                        <div className="price-filter">
                                            <input type="text" id="range-price-slider" value="" name="range"/>
                                        </div>
                                    </div>
                                </div>

                                <div className="filter-box active">
                                    <div className="title">
                                        Colors
                                    </div>
                                    <div className="filter-content" style={{display: "block"}}>
                                        <div className="product-colors clearfix">
                                            <span className="color-btn color-btn-yellow"></span>
                                            <span className="color-btn color-btn-pink"></span>
                                            <span className="color-btn color-btn-orange"></span>
                                            <span className="color-btn color-btn-red"></span>
                                            <span className="color-btn color-btn-blue checked"></span>
                                            <span className="color-btn color-btn-green"></span>
                                            <span className="color-btn color-btn-gray"></span>
                                            <span className="color-btn color-btn-biege"></span>
                                            <span className="color-btn color-btn-black"></span>
                                            <span className="color-btn color-btn-white"></span>
                                        </div>
                                    </div>
                                </div>


                                <div className="filter-box active">
                                    <div className="title">
                                        Availability
                                    </div>
                                    <div className="filter-content" style={{display: "block"}}>
                                <span className="checkbox">
                                    <input type="checkbox" id="availableId1" checked="checked"/>
                                    <label htmlFor="availableId1">In stock <i>(152)</i></label>
                                </span>
                                        <span className="checkbox">
                                    <input type="checkbox" id="availableId2"/>
                                    <label htmlFor="availableId2">1 Week <i>(100)</i></label>
                                </span>
                                        <span className="checkbox">
                                    <input type="checkbox" id="availableId3"/>
                                    <label htmlFor="availableId3">2 Weeks <i>(80)</i></label>
                                </span>
                                    </div>
                                </div>


                                <div className="filter-box active">
                                    <div className="title">
                                        Discount
                                    </div>
                                    <div className="filter-content" style={{display: "block"}}>
                                <span className="checkbox">
                                    <input type="radio" id="discountId1" name="discountPrice" checked="checked"/>
                                    <label htmlFor="discountId1">Discount price</label>
                                </span>
                                        <span className="checkbox">
                                    <input type="radio" id="discountId2" name="discountPrice"/>
                                    <label htmlFor="discountId2">Regular price</label>
                                </span>
                                    </div>
                                </div>


                                <div className="filter-box active">
                                    <div className="title">
                                        Type
                                    </div>
                                    <div className="filter-content" style={{display: "block"}}>
                                <span className="checkbox">
                                    <input type="checkbox" id="typeId1"/>
                                    <label htmlFor="typeId1">Shoes <i>(1200)</i></label>
                                </span>
                                        <span className="checkbox">
                                    <input type="checkbox" id="typeId2"/>
                                    <label htmlFor="typeId2">Gadgets <i>(12)</i></label>
                                </span>
                                        <span className="checkbox">
                                    <input type="checkbox" id="typeId3"/>
                                    <label htmlFor="typeId3">TV & Video <i>(80)</i></label>
                                </span>
                                        <span className="checkbox">
                                    <input type="checkbox" id="typeId4"/>
                                    <label htmlFor="typeId4">Drones <i>(140)</i></label>
                                </span>
                                        <span className="checkbox">
                                    <input type="checkbox" id="typeId5"/>
                                    <label htmlFor="typeId5">Media storage <i>(20)</i></label>
                                </span>
                                        <span className="checkbox">
                                    <input type="checkbox" id="typeId6"/>
                                    <label htmlFor="typeId6">Cameras <i>(10)</i></label>
                                </span>
                                        <span className="checkbox">
                                    <input type="checkbox" id="typeId7"/>
                                    <label htmlFor="typeId7">Bookcase <i>(450)</i></label>
                                </span>
                                        <span className="checkbox">
                                    <input type="checkbox" id="typeId8"/>
                                    <label htmlFor="typeId8">Mobile phones <i>(750)</i></label>
                                </span>
                                        <span className="checkbox">
                                    <input type="checkbox" id="typeId9"/>
                                    <label htmlFor="typeId9">Accessories <i>(960)</i></label>
                                </span>
                                        <span className="checkbox">
                                    <input type="checkbox" id="typeId10"/>
                                    <label htmlFor="typeId10">Home <i>(44)</i></label>
                                </span>
                                        <span className="checkbox">
                                    <input type="checkbox" id="typeId11"/>
                                    <label htmlFor="typeId11">Projectors <i>(5)</i></label>
                                </span>
                                        <span className="checkbox">
                                    <input type="checkbox" id="typeId12"/>
                                    <label htmlFor="typeId12">Movies & TV <i>(80)</i></label>
                                </span>
                                        <span className="checkbox">
                                    <input type="checkbox" id="typeId13"/>
                                    <label htmlFor="typeId13">Fashion <i>(23)</i></label>
                                </span>
                                        <span className="checkbox">
                                    <input type="checkbox" id="typeId14"/>
                                    <label htmlFor="typeId14">Toys <i>(24)</i></label>
                                </span>
                                        <span className="checkbox">
                                    <input type="checkbox" id="typeId15"/>
                                    <label htmlFor="typeId15">Musical Instruments <i>(92)</i></label>
                                </span>
                                        <span className="checkbox">
                                    <input type="checkbox" id="typeId16"/>
                                    <label htmlFor="typeId16">Lightning <i>(1120)</i></label>
                                </span>
                                    </div>
                                </div>


                                <div className="filter-box active">
                                    <div className="title">
                                        Material
                                    </div>
                                    <div className="filter-content" style={{display: "block"}}>
                                <span className="checkbox">
                                    <input type="checkbox" id="matId1"/>
                                    <label htmlFor="matId1">Blend <i>(1200)</i></label>
                                </span>
                                        <span className="checkbox">
                                    <input type="checkbox" id="matId2"/>
                                    <label htmlFor="matId2">Leather <i>(12)</i></label>
                                </span>
                                        <span className="checkbox">
                                    <input type="checkbox" id="matId3"/>
                                    <label htmlFor="matId3">Wood <i>(80)</i></label>
                                </span>
                                        <span className="checkbox">
                                    <input type="checkbox" id="matId4"/>
                                    <label htmlFor="matId4">Shell <i>(80)</i></label>
                                </span>
                                        <span className="checkbox">
                                    <input type="checkbox" id="matId5"/>
                                    <label htmlFor="matId5">Metal <i>(80)</i></label>
                                </span>
                                    </div>
                                </div>


                                <div className="toggle-filters-close btn btn-main">
                                    Update search
                                </div>

                            </div>

                        </div>


                        <div className="col-md-9 col-xs-12">

                            <div className="sort-bar clearfix">
                                <div className="sort-results pull-left">

                                    <select>
                                        <option value="1">10</option>
                                        <option value="2">50</option>
                                        <option value="3">100</option>
                                        <option value="4">All</option>
                                    </select>

                                    <span>Showing all <strong>50</strong> of <strong>3,250</strong> items</span>
                                </div>

                                <div className="sort-options pull-right">
                                    <span className="hidden-xs">Sort by</span>
                                    <select>
                                        <option value="1">Name</option>
                                        <option value="2">Popular items</option>
                                        <option value="3">Price: lowest</option>
                                        <option value="4">Price: highest</option>
                                    </select>

                                    <span className="grid-list">
                                <a href="products-grid.html"><i className="fa fa-th-large"></i></a>
                                <a href="products-list.html"><i className="fa fa-align-justify"></i></a>
                                <a href="javascript:void(0);" className="toggle-filters-mobile"><i
                                    className="fa fa-search"></i></a>
                            </span>
                                </div>
                            </div>

                            <div className="row row-clean">


                                <div className="col-xs-6 col-sm-4 col-lg-3">
                                    <article>
                                        <div className="info">
                                    <span className="add-favorite">
                                        <a href="javascript:void(0);" data-title="Add to favorites"
                                           data-title-added="Added to favorites list"><i
                                            className="icon icon-heart"></i></a>
                                    </span>
                                            <span>
                                        <a href="#productid1" className="mfp-open" data-title="Quick wiew"><i
                                            className="icon icon-eye"></i></a>
                                    </span>
                                        </div>
                                        <div className="btn btn-add">
                                            <i className="icon icon-cart"></i>
                                        </div>
                                        <div className="figure-grid">
                                            <div className="image">
                                                <a href="#productid1" className="mfp-open">
                                                    <img src="assets/images/product-7.png" alt="" width="360"/>
                                                </a>
                                            </div>
                                            <div className="text">
                                                <h2 className="title h4">
                                                    <a href="product.html">Coffee machine</a>
                                                </h2>
                                                <sub>$ 159,-</sub>
                                                <sup>$ 139,-</sup>
                                                <span className="description clearfix">Gubergren amet dolor ea diam takimata consetetur facilisis blandit et aliquyam lorem ea duo labore diam sit et consetetur nulla</span>
                                            </div>
                                        </div>
                                    </article>
                                </div>


                                <div className="col-xs-6 col-sm-4 col-lg-3">
                                    <article>
                                        <div className="info">
                                    <span className="add-favorite">
                                        <a href="javascript:void(0);" data-title="Add to favorites"
                                           data-title-added="Added to favorites list"><i
                                            className="icon icon-heart"></i></a>
                                    </span>
                                            <span>
                                        <a href="#productid1" className="mfp-open" data-title="Quick wiew"><i
                                            className="icon icon-eye"></i></a>
                                    </span>
                                        </div>
                                        <div className="btn btn-add">
                                            <i className="icon icon-cart"></i>
                                        </div>
                                        <div className="figure-grid">
                                            <span className="label label-danger">-50%</span>
                                            <div className="image">
                                                <a href="#productid1" className="mfp-open">
                                                    <img src="assets/images/product-8.png" alt="" width="360"/>
                                                </a>
                                            </div>
                                            <div className="text">
                                                <h2 className="title h4">
                                                    <a href="product.html">Iron set</a>
                                                </h2>
                                                <sub>$ 1999,-</sub>
                                                <sup>$ 1499,-</sup>
                                                <span className="description clearfix">Gubergren amet dolor ea diam takimata consetetur facilisis blandit et aliquyam lorem ea duo labore diam sit et consetetur nulla</span>
                                            </div>
                                        </div>
                                    </article>
                                </div>


                                <div className="col-xs-6 col-sm-4 col-lg-3">
                                    <article>
                                        <div className="info">
                                    <span className="add-favorite">
                                        <a href="javascript:void(0);" data-title="Add to favorites"
                                           data-title-added="Added to favorites list"><i
                                            className="icon icon-heart"></i></a>
                                    </span>
                                            <span>
                                        <a href="#productid1" className="mfp-open" data-title="Quick wiew"><i
                                            className="icon icon-eye"></i></a>
                                    </span>
                                        </div>
                                        <div className="btn btn-add">
                                            <i className="icon icon-cart"></i>
                                        </div>
                                        <div className="figure-grid">
                                            <div className="image">
                                                <a href="#productid1" className="mfp-open">
                                                    <img src="assets/images/product-9.png" alt="" width="360"/>
                                                </a>
                                            </div>
                                            <div className="text">
                                                <h2 className="title h4">
                                                    <a href="product.html">Projector 4k</a>
                                                </h2>
                                                <sub>$ 1999,-</sub>
                                                <sup>$ 1499,-</sup>
                                                <span className="description clearfix">Gubergren amet dolor ea diam takimata consetetur facilisis blandit et aliquyam lorem ea duo labore diam sit et consetetur nulla</span>
                                            </div>
                                        </div>
                                    </article>
                                </div>


                                <div className="col-xs-6 col-sm-4 col-lg-3">
                                    <article>
                                        <div className="info">
                                    <span className="add-favorite">
                                        <a href="javascript:void(0);" data-title="Add to favorites"
                                           data-title-added="Added to favorites list"><i
                                            className="icon icon-heart"></i></a>
                                    </span>
                                            <span>
                                        <a href="#productid1" className="mfp-open" data-title="Quick wiew"><i
                                            className="icon icon-eye"></i></a>
                                    </span>
                                        </div>
                                        <div className="btn btn-add">
                                            <i className="icon icon-cart"></i>
                                        </div>
                                        <div className="figure-grid">
                                            <span className="label label-info">-20%</span>
                                            <div className="image">
                                                <a href="#productid1" className="mfp-open">
                                                    <img src="assets/images/product-10.png" alt="" width="360"/>
                                                </a>
                                            </div>
                                            <div className="text">
                                                <h2 className="title h4">
                                                    <a href="product.html">Headphones Wireless</a>
                                                </h2>
                                                <sub>$ 1999,-</sub>
                                                <sup>$ 1499,-</sup>
                                                <span className="description clearfix">Gubergren amet dolor ea diam takimata consetetur facilisis blandit et aliquyam lorem ea duo labore diam sit et consetetur nulla</span>
                                            </div>
                                        </div>
                                    </article>
                                </div>


                                <div className="col-xs-6 col-sm-4 col-lg-3">
                                    <article>
                                        <div className="info">
                                    <span className="add-favorite">
                                        <a href="javascript:void(0);" data-title="Add to favorites"
                                           data-title-added="Added to favorites list"><i
                                            className="icon icon-heart"></i></a>
                                    </span>
                                            <span>
                                        <a href="#productid1" className="mfp-open" data-title="Quick wiew"><i
                                            className="icon icon-eye"></i></a>
                                    </span>
                                        </div>
                                        <div className="btn btn-add">
                                            <i className="icon icon-cart"></i>
                                        </div>
                                        <div className="figure-grid">
                                            <div className="image">
                                                <a href="#productid1" className="mfp-open">
                                                    <img src="assets/images/product-11.png" alt="" width="360"/>
                                                </a>
                                            </div>
                                            <div className="text">
                                                <h2 className="title h4">
                                                    <a href="product.html">Vacuum cleaner</a>
                                                </h2>
                                                <sub>$ 1999,-</sub>
                                                <sup>$ 1499,-</sup>
                                                <span className="description clearfix">Gubergren amet dolor ea diam takimata consetetur facilisis blandit et aliquyam lorem ea duo labore diam sit et consetetur nulla</span>
                                            </div>
                                        </div>
                                    </article>
                                </div>


                                <div className="col-xs-6 col-sm-4 col-lg-3">
                                    <article>
                                        <div className="info">
                                    <span className="add-favorite">
                                        <a href="javascript:void(0);" data-title="Add to favorites"
                                           data-title-added="Added to favorites list"><i
                                            className="icon icon-heart"></i></a>
                                    </span>
                                            <span>
                                        <a href="#productid1" className="mfp-open" data-title="Quick wiew"><i
                                            className="icon icon-eye"></i></a>
                                    </span>
                                        </div>
                                        <div className="btn btn-add">
                                            <i className="icon icon-cart"></i>
                                        </div>
                                        <div className="figure-grid">
                                            <div className="image">
                                                <a href="#productid1" className="mfp-open">
                                                    <img src="assets/images/product-12.png" alt="" width="360"/>
                                                </a>
                                            </div>
                                            <div className="text">
                                                <h2 className="title h4">
                                                    <a href="product.html">E-shaver 500</a>
                                                </h2>
                                                <sub>$ 1999,-</sub>
                                                <sup>$ 1499,-</sup>
                                                <span className="description clearfix">Gubergren amet dolor ea diam takimata consetetur facilisis blandit et aliquyam lorem ea duo labore diam sit et consetetur nulla</span>
                                            </div>
                                        </div>
                                    </article>
                                </div>


                                <div className="col-xs-6 col-sm-4 col-lg-3">

                                    <article>
                                        <div className="info">
                                    <span className="add-favorite">
                                        <a href="javascript:void(0);" data-title="Add to favorites"
                                           data-title-added="Added to favorites list"><i
                                            className="icon icon-heart"></i></a>
                                    </span>
                                            <span>
                                        <a href="#productid1" className="mfp-open" data-title="Quick wiew"><i
                                            className="icon icon-eye"></i></a>
                                    </span>
                                        </div>
                                        <div className="btn btn-add">
                                            <i className="icon icon-cart"></i>
                                        </div>
                                        <div className="figure-grid">
                                            <div className="image">
                                                <a href="#productid1" className="mfp-open">
                                                    <img src="assets/images/cloth-1.jpg" alt="" width="360"/>
                                                </a>
                                            </div>
                                            <div className="text">
                                                <h2 className="title h4">
                                                    <a href="product.html">Elegant shoe</a>
                                                </h2>
                                                <sub>$ 199,-</sub>
                                                <sup>$ 99,-</sup>
                                                <span className="description clearfix">Gubergren amet dolor ea diam takimata consetetur facilisis blandit et aliquyam lorem ea duo labore diam sit et consetetur nulla</span>
                                            </div>
                                        </div>
                                    </article>
                                </div>


                                <div className="col-xs-6 col-sm-4 col-lg-3">
                                    <article>
                                        <div className="info">
                                    <span className="add-favorite">
                                        <a href="javascript:void(0);" data-title="Add to favorites"
                                           data-title-added="Added to favorites list"><i
                                            className="icon icon-heart"></i></a>
                                    </span>
                                            <span>
                                        <a href="#productid1" className="mfp-open" data-title="Quick wiew"><i
                                            className="icon icon-eye"></i></a>
                                    </span>
                                        </div>
                                        <div className="btn btn-add">
                                            <i className="icon icon-cart"></i>
                                        </div>
                                        <div className="figure-grid">
                                            <div className="image">
                                                <a href="#productid1" className="mfp-open">
                                                    <img src="assets/images/cloth-2.jpg" alt="" width="360"/>
                                                </a>
                                            </div>
                                            <div className="text">
                                                <h2 className="title h4">
                                                    <a href="product.html">Polo shirt</a>
                                                </h2>
                                                <sub>$ 159,-</sub>
                                                <sup>$ 129,-</sup>
                                                <span className="description clearfix">Gubergren amet dolor ea diam takimata consetetur facilisis blandit et aliquyam lorem ea duo labore diam sit et consetetur nulla</span>
                                            </div>
                                        </div>
                                    </article>
                                </div>


                                <div className="col-xs-6 col-sm-4 col-lg-3">
                                    <article>
                                        <div className="info">
                                    <span className="add-favorite">
                                        <a href="javascript:void(0);" data-title="Add to favorites"
                                           data-title-added="Added to favorites list"><i
                                            className="icon icon-heart"></i></a>
                                    </span>
                                            <span>
                                        <a href="#productid1" className="mfp-open" data-title="Quick wiew"><i
                                            className="icon icon-eye"></i></a>
                                    </span>
                                        </div>
                                        <div className="btn btn-add">
                                            <i className="icon icon-cart"></i>
                                        </div>
                                        <div className="figure-grid">
                                            <span className="label label-warning">New</span>
                                            <div className="image">
                                                <a href="#productid1" className="mfp-open">
                                                    <img src="assets/images/cloth-3.jpg" alt="" width="360"/>
                                                </a>
                                            </div>
                                            <div className="text">
                                                <h2 className="title h4">
                                                    <a href="product.html">T-shirt</a>
                                                </h2>
                                                <sup>$ 29,-</sup>
                                                <span className="description clearfix">Gubergren amet dolor ea diam takimata consetetur facilisis blandit et aliquyam lorem ea duo labore diam sit et consetetur nulla</span>
                                            </div>
                                        </div>
                                    </article>
                                </div>


                                <div className="col-xs-6 col-sm-4 col-lg-3">
                                    <article>
                                        <div className="info">
                                    <span className="add-favorite added">
                                        <a href="javascript:void(0);" data-title="Add to favorites"
                                           data-title-added="Added to favorites list"><i
                                            className="icon icon-heart"></i></a>
                                    </span>
                                            <span>
                                        <a href="#productid1" className="mfp-open" data-title="Quick wiew"><i
                                            className="icon icon-eye"></i></a>
                                    </span>
                                        </div>
                                        <div className="btn btn-add">
                                            <i className="icon icon-cart"></i>
                                        </div>
                                        <div className="figure-grid">
                                            <div className="image">
                                                <a href="#productid1" className="mfp-open">
                                                    <img src="assets/images/cloth-4.jpg" alt="" width="360"/>
                                                </a>
                                            </div>
                                            <div className="text">
                                                <h2 className="title h4">
                                                    <a href="product.html">Winter Jacket</a>
                                                </h2>
                                                <sup>$ 299,-</sup>
                                                <span className="description clearfix">Gubergren amet dolor ea diam takimata consetetur facilisis blandit et aliquyam lorem ea duo labore diam sit et consetetur nulla</span>
                                            </div>
                                        </div>
                                    </article>
                                </div>


                                <div className="col-xs-6 col-sm-4 col-lg-3">
                                    <article>
                                        <div className="info">
                                    <span className="add-favorite">
                                        <a href="javascript:void(0);" data-title="Add to favorites"
                                           data-title-added="Added to favorites list"><i
                                            className="icon icon-heart"></i></a>
                                    </span>
                                            <span>
                                        <a href="#productid1" className="mfp-open" data-title="Quick wiew"><i
                                            className="icon icon-eye"></i></a>
                                    </span>
                                        </div>
                                        <div className="btn btn-add">
                                            <i className="icon icon-cart"></i>
                                        </div>
                                        <div className="figure-grid">
                                            <span className="label label-info">-50%</span>
                                            <div className="image">
                                                <a href="#productid1" className="mfp-open">
                                                    <img src="assets/images/cloth-5.jpg" alt="" width="360"/>
                                                </a>
                                            </div>
                                            <div className="text">
                                                <h2 className="title h4">
                                                    <a href="product.html">Sweater</a>
                                                </h2>
                                                <sub>$ 49,-</sub>
                                                <sup>$ 19,-</sup>
                                                <span className="description clearfix">Gubergren amet dolor ea diam takimata consetetur facilisis blandit et aliquyam lorem ea duo labore diam sit et consetetur nulla</span>
                                            </div>
                                        </div>
                                    </article>
                                </div>


                                <div className="col-xs-6 col-sm-4 col-lg-3">
                                    <article>
                                        <div className="info">
                                    <span className="add-favorite">
                                        <a href="javascript:void(0);" data-title="Add to favorites"
                                           data-title-added="Added to favorites list"><i
                                            className="icon icon-heart"></i></a>
                                    </span>
                                            <span>
                                        <a href="#productid1" className="mfp-open" data-title="Quick wiew"><i
                                            className="icon icon-eye"></i></a>
                                    </span>
                                        </div>
                                        <div className="btn btn-add">
                                            <i className="icon icon-cart"></i>
                                        </div>
                                        <div className="figure-grid">
                                            <div className="image">
                                                <a href="#productid1" className="mfp-open">
                                                    <img src="assets/images/cloth-6.jpg" alt="" width="360"/>
                                                </a>
                                            </div>
                                            <div className="text">
                                                <h2 className="title h4">
                                                    <a href="product.html">Lether jacket</a>
                                                </h2>
                                                <sup>$ 499,-</sup>
                                                <span className="description clearfix">Gubergren amet dolor ea diam takimata consetetur facilisis blandit et aliquyam lorem ea duo labore diam sit et consetetur nulla</span>
                                            </div>
                                        </div>
                                    </article>
                                </div>


                                <div className="col-xs-6 col-sm-4 col-lg-3">
                                    <article>
                                        <div className="info">
                                    <span className="add-favorite">
                                        <a href="javascript:void(0);" data-title="Add to favorites"
                                           data-title-added="Added to favorites list"><i
                                            className="icon icon-heart"></i></a>
                                    </span>
                                            <span>
                                        <a href="#productid1" className="mfp-open" data-title="Quick wiew"><i
                                            className="icon icon-eye"></i></a>
                                    </span>
                                        </div>
                                        <div className="btn btn-add">
                                            <i className="icon icon-cart"></i>
                                        </div>
                                        <div className="figure-grid">
                                            <div className="image">
                                                <a href="#productid1" className="mfp-open">
                                                    <img src="assets/images/product-1.png" alt="" width="360"/>
                                                </a>
                                            </div>
                                            <div className="text">
                                                <h2 className="title h4">
                                                    <a href="product.html">Man Shoe</a>
                                                </h2>
                                                <sup>$ 139,-</sup>
                                                <span className="description clearfix">Gubergren amet dolor ea diam takimata consetetur facilisis blandit et aliquyam lorem ea duo labore diam sit et consetetur nulla</span>
                                            </div>
                                        </div>
                                    </article>
                                </div>


                                <div className="col-xs-6 col-sm-4 col-lg-3">
                                    <article>
                                        <div className="info">
                                    <span className="add-favorite">
                                        <a href="javascript:void(0);" data-title="Add to favorites"
                                           data-title-added="Added to favorites list"><i
                                            className="icon icon-heart"></i></a>
                                    </span>
                                            <span>
                                        <a href="#productid1" className="mfp-open" data-title="Quick wiew"><i
                                            className="icon icon-eye"></i></a>
                                    </span>
                                        </div>
                                        <div className="btn btn-add">
                                            <i className="icon icon-cart"></i>
                                        </div>
                                        <div className="figure-grid">
                                            <div className="image">
                                                <a href="#productid1" className="mfp-open">
                                                    <img src="assets/images/product-2.png" alt="" width="360"/>
                                                </a>
                                            </div>
                                            <div className="text">
                                                <h2 className="title h4">
                                                    <a href="product.html">Sport watch</a>
                                                </h2>
                                                <sub>$ 365,-</sub>
                                                <sup>$ 245,-</sup>
                                                <span className="description clearfix">Gubergren amet dolor ea diam takimata consetetur facilisis blandit et aliquyam lorem ea duo labore diam sit et consetetur nulla</span>
                                            </div>
                                        </div>
                                    </article>
                                </div>


                                <div className="col-xs-6 col-sm-4 col-lg-3">
                                    <article>
                                        <div className="info">
                                    <span className="add-favorite">
                                        <a href="javascript:void(0);" data-title="Add to favorites"
                                           data-title-added="Added to favorites list"><i
                                            className="icon icon-heart"></i></a>
                                    </span>
                                            <span>
                                        <a href="#productid1" className="mfp-open" data-title="Quick wiew"><i
                                            className="icon icon-eye"></i></a>
                                    </span>
                                        </div>
                                        <div className="btn btn-add">
                                            <i className="icon icon-cart"></i>
                                        </div>
                                        <div className="figure-grid">
                                            <div className="image">
                                                <a href="#productid1" className="mfp-open">
                                                    <img src="assets/images/product-3.png" alt="" width="360"/>
                                                </a>
                                            </div>
                                            <div className="text">
                                                <h2 className="title h4">
                                                    <a href="product.html">4k TV</a>
                                                </h2>
                                                <sub>$ 2999,-</sub>
                                                <sup>$ 2699,-</sup>
                                                <span className="description clearfix">Gubergren amet dolor ea diam takimata consetetur facilisis blandit et aliquyam lorem ea duo labore diam sit et consetetur nulla</span>
                                            </div>
                                        </div>
                                    </article>
                                </div>


                                <div className="col-xs-6 col-sm-4 col-lg-3">
                                    <article>
                                        <div className="info">
                                    <span className="add-favorite">
                                        <a href="javascript:void(0);" data-title="Add to favorites"
                                           data-title-added="Added to favorites list"><i
                                            className="icon icon-heart"></i></a>
                                    </span>
                                            <span>
                                        <a href="#productid1" className="mfp-open" data-title="Quick wiew"><i
                                            className="icon icon-eye"></i></a>
                                    </span>
                                        </div>
                                        <div className="btn btn-add">
                                            <i className="icon icon-cart"></i>
                                        </div>
                                        <div className="figure-grid">
                                            <div className="image">
                                                <a href="#productid1" className="mfp-open">
                                                    <img src="assets/images/product-4.png" alt="" width="360"/>
                                                </a>
                                            </div>
                                            <div className="text">
                                                <h2 className="title h4">
                                                    <a href="product.html">Drone machine</a>
                                                </h2>
                                                <sub>$ 499,-</sub>
                                                <sup>$ 399,-</sup>
                                                <span className="description clearfix">Gubergren amet dolor ea diam takimata consetetur facilisis blandit et aliquyam lorem ea duo labore diam sit et consetetur nulla</span>
                                            </div>
                                        </div>
                                    </article>
                                </div>

                            </div>


                            <div className="pagination-wrapper">
                                <ul className="pagination">
                                    <li>
                                        <a href="#" aria-label="Previous">
                                            <span aria-hidden="true">&laquo;</span>
                                        </a>
                                    </li>
                                    <li className="active"><a href="#">1</a></li>
                                    <li><a href="#">2</a></li>
                                    <li><a href="#">3</a></li>
                                    <li><a href="#">4</a></li>
                                    <li><a href="#">5</a></li>
                                    <li>
                                        <a href="#" aria-label="Next">
                                            <span aria-hidden="true">&raquo;</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>

                        </div>


                    </div>


                    <div className="popup-main mfp-hide" id="productid1">


                        <div className="product">


                            <div className="popup-title">
                                <div className="h1 title">
                                    Headphones Wireless
                                    <small>product category</small>
                                </div>
                            </div>


                            <div className="owl-product-gallery">
                                <img src="assets/images/product-10.png" alt="" width="640"/>
                                <img src="assets/images/product-10a.png" alt="" width="640"/>
                            </div>


                            <div className="popup-content">
                                <div className="product-info-wrapper">
                                    <div className="row">


                                        <div className="col-sm-6">
                                            <div className="info-box">
                                                <strong>Maifacturer</strong>
                                                <span>Brand name</span>
                                            </div>
                                            <div className="info-box">
                                                <strong>Materials</strong>
                                                <span>Wood, Leather, Acrylic</span>
                                            </div>
                                            <div className="info-box">
                                                <strong>Availability</strong>
                                                <span><i className="fa fa-check-square-o"></i> in stock</span>
                                            </div>
                                        </div>


                                        <div className="col-sm-6">
                                            <div className="info-box">
                                                <strong>Available Colors</strong>
                                                <div className="product-colors clearfix">
                                                    <span className="color-btn color-btn-red"></span>
                                                    <span className="color-btn color-btn-blue checked"></span>
                                                    <span className="color-btn color-btn-green"></span>
                                                    <span className="color-btn color-btn-gray"></span>
                                                    <span className="color-btn color-btn-biege"></span>
                                                </div>
                                            </div>
                                            <div className="info-box">
                                                <strong>Choose size</strong>
                                                <div className="product-colors clearfix">
                                                    <span className="color-btn color-btn-biege">S</span>
                                                    <span className="color-btn color-btn-biege checked">M</span>
                                                    <span className="color-btn color-btn-biege">XL</span>
                                                    <span className="color-btn color-btn-biege">XXL</span>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>

                            </div>


                            <div className="popup-table">
                                <div className="popup-cell">
                                    <div className="price">
                                        <span className="h3">$ 1999,00 <small>$ 2999,00</small></span>
                                    </div>
                                </div>
                                <div className="popup-cell">
                                    <div className="popup-buttons">
                                        <a href="product.html"><span className="icon icon-eye"></span> <span
                                            className="hidden-xs">View more</span></a>
                                        <a href="javascript:void(0);"><span className="icon icon-cart"></span> <span
                                            className="hidden-xs">Buy</span></a>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>


                </section>

                <Footer/>

            </div>

        </React.Fragment>
);
}